import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { ProfitAndLossApi } from '../profitAndLoss.api';

export const useGetProfitAndLossCalculations = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: ProfitAndLossApi.getCalculationsOfProfitAndLoss,
  });
};
